(function () {
  'use strict';

  var STYLING_PACK_VARIANT_ID = 48263902462182;
  var OATH_PRODUCT_HANDLE = 'oath-of-ashes-cloak-fireburn-collection-offer';
  var isChecking = false;
  var lastCheck = 0;

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function removeStylePack(cart) {
    var stylingItem = cart.items.find(function (item) {
      return item.variant_id === STYLING_PACK_VARIANT_ID;
    });
    if (!stylingItem) return Promise.resolve();

    var updates = {};
    updates[stylingItem.key] = 0;

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
  }

  function oathIsInCart(cart) {
    return cart.items.some(function (item) {
      return item.handle === OATH_PRODUCT_HANDLE;
    });
  }

  function stylingPackIsInCart(cart) {
    return cart.items.some(function (item) {
      return item.variant_id === STYLING_PACK_VARIANT_ID;
    });
  }

  function checkAndSync() {
    var now = Date.now();
    if (isChecking || now - lastCheck < 3000) return;
    isChecking = true;
    lastCheck = now;
    getCart().then(function (cart) {
      if (!oathIsInCart(cart) && stylingPackIsInCart(cart)) {
        removeStylePack(cart).then(function () {
          isChecking = false;
        });
      } else {
        isChecking = false;
      }
    }).catch(function () {
      isChecking = false;
    });
  }

  setInterval(checkAndSync, 5000);
  checkAndSync();

})();